import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { userClient } from '../client/userClient';


export type Params = {
  id: string;
};

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useUser = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: user } = {}, status, error } = useSuspenseQuery({
    queryKey: [cacheKeys.getUser, params.id],
    queryFn: () => userClient.getUser(params),
  });

  return {
    status,
    error,
    user,
  };
};
